import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Contact2, FileText, CheckCircle2, MessageSquare, PhoneCall, FolderKanban, CalendarCheck, Users, Plus, UserPlus, CalendarRange, Globe } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StatCard, PageHeader } from "@/components/dashboard/ui";
import { Button } from "@/components/ui/button";

export default function AdminDashboard() {
  const { user } = useAuth();
  const [s, setS] = useState({});
  const navigate = useNavigate();
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setS(data || {})); }, []);

  return (
    <div>
      <PageHeader title={`Bonjour ${user?.first_name}`} subtitle="Vue d'ensemble de l'activité Delya." />

      <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">Action requise</h2>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
        <StatCard icon={Contact2} label="Nouveaux prospects" value={s.new_leads ?? "—"} tone="accent" onClick={() => navigate("/admin/prospects")} testid="admin-stat-leads" />
        <StatCard icon={FileText} label="À attribuer" value={s.awaiting_assignment ?? "—"} tone="amber" onClick={() => navigate("/admin/demandes")} testid="admin-stat-assign" />
        <StatCard icon={CheckCircle2} label="À confirmer" value={s.awaiting_confirmation ?? "—"} tone="primary" onClick={() => navigate("/admin/planning")} />
        <StatCard icon={MessageSquare} label="Messages non lus" value={s.unread_messages ?? "—"} tone="primary" onClick={() => navigate("/admin/messages")} />
        <StatCard icon={PhoneCall} label="Rappels urgents" value={s.urgent_callbacks ?? "—"} tone="rose" onClick={() => navigate("/admin/rappels-urgents")} testid="admin-stat-callbacks" />
        <StatCard icon={FolderKanban} label="Projets actifs" value={s.project_requests ?? "—"} tone="accent" onClick={() => navigate("/admin/projets")} />
      </div>

      <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">Aujourd'hui & cette semaine</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard icon={CalendarCheck} label="Missions aujourd'hui" value={s.missions_today ?? "—"} tone="primary" />
        <StatCard icon={CalendarRange} label="Missions cette semaine" value={s.missions_week ?? "—"} tone="accent" />
        <StatCard icon={Users} label="Personnel actif" value={s.active_staff ?? "—"} tone="emerald" />
        <StatCard icon={Users} label="Clients" value={s.total_clients ?? "—"} tone="primary" />
      </div>

      <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">Raccourcis</h2>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" onClick={() => navigate("/admin/demandes")}><Plus className="h-4 w-4 mr-1.5" />Demandes</Button>
        <Button variant="outline" onClick={() => navigate("/admin/equipe")}><UserPlus className="h-4 w-4 mr-1.5" />Ajouter un membre</Button>
        <Button variant="outline" onClick={() => navigate("/admin/planning")}><CalendarRange className="h-4 w-4 mr-1.5" />Planning équipe</Button>
        <Button variant="outline" onClick={() => navigate("/admin/services")}><FileText className="h-4 w-4 mr-1.5" />Services</Button>
        <Button variant="outline" onClick={() => navigate("/admin/site")}><Globe className="h-4 w-4 mr-1.5" />Modifier le site</Button>
      </div>
    </div>
  );
}
